import { render, staticRenderFns } from "./Dienstleister.vue?vue&type=template&id=6bb2b3f3&scoped=true&"
import script from "./Dienstleister.vue?vue&type=script&lang=js&"
export * from "./Dienstleister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2b3f3",
  null
  
)

export default component.exports